import React from 'react';
import { Layout as DefaultLayout } from 'tenants/_template/desktop/_module/Layout';
import { useGlobalData } from 'contexts';
import { LanguageSelector } from 'components/desktop/organisms';
import { renderTopBarMenu } from '../../../_template/desktop/_helpers';
import { translateObject } from 'helpers/translate';

export const Layout: React.FunctionComponent<LayoutProps> = ({
  children,
  ...props
}: LayoutProps) => {
  const {
    partner,
    footerDataConfig = {},
    vietinFooterDataConfig = {},
    rightMenuTopBarButtonConfigs = [],
  } = useGlobalData();
  const isVietin = partner === 'vietin';

  const rightMenu = renderTopBarMenu(
    translateObject(rightMenuTopBarButtonConfigs),
    [() => <LanguageSelector />],
  );
  const footerData = isVietin
    ? translateObject(vietinFooterDataConfig as object)
    : translateObject(footerDataConfig as object);

  return (
    <DefaultLayout {...props} rightMenu={rightMenu} footerData={footerData}>
      {children}
    </DefaultLayout>
  );
};
